var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.21875C17.5625 5.53125 17.5625 6 17.25 6.28125L9 14.5312C8.71875 14.8438 8.25 14.8438 7.96875 14.5312L3.71875 10.2812C3.40625 10 3.40625 9.53125 3.71875 9.21875C4 8.9375 4.46875 8.9375 4.75 9.21875L8.5 12.9688L16.2188 5.21875C16.5 4.9375 16.9688 4.9375 17.25 5.21875Z",
    fill: "#85B645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApproved);
export default __webpack_public_path__ + "static/media/icon-approved.43dd0f4b4b51b8fd70ed15cb1e404c57.svg";
export { ForwardRef as ReactComponent };